var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "quick-pick-filter" },
    [
      _vm.toggles
        ? _c(
            "v-btn-toggle",
            {
              attrs: { multiple: "" },
              model: {
                value: _vm.quickPickSelection,
                callback: function ($$v) {
                  _vm.quickPickSelection = $$v
                },
                expression: "quickPickSelection",
              },
            },
            _vm._l(_vm.items, function (item) {
              return _c("v-hover", {
                key: item.value,
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ hover }) {
                        return [
                          _c(
                            "v-btn",
                            {
                              staticClass: "selection-button",
                              class: { "on-hover": hover },
                              attrs: { value: item.value, ripple: false },
                              on: {
                                dblclick: function ($event) {
                                  return _vm.toggleOnly(item.value, $event)
                                },
                              },
                            },
                            [
                              item.icon &&
                              _vm.quickPickSelection.includes(item.value)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "qp-btn-icon",
                                      class: item.colorClass,
                                    },
                                    [_c("i", { class: item.icon })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              item.disabledIcon &&
                              !_vm.quickPickSelection.includes(item.value)
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "qp-btn-icon",
                                      class: item.colorClass,
                                    },
                                    [_c("i", { class: item.disabledIcon })]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !item.icon && item.svgSrc
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "qp-btn-svg",
                                      class: item.colorClass,
                                    },
                                    [
                                      _c("img", {
                                        class: item.svgClass,
                                        style: item.svgStyle,
                                        attrs: { src: item.svgSrc },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", { staticClass: "flex-break" }),
                              _vm._v(" "),
                              item.title
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "qp-btn-label",
                                      class: item.colorClass,
                                    },
                                    [_vm._v(_vm._s(item.title))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-fade-transition",
                                [
                                  _c("v-hover", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ hover }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "only-btn",
                                                  class: [
                                                    {
                                                      "on-hover": hover,
                                                      "icon-only":
                                                        item.icon &&
                                                        !item.title,
                                                      "title-only":
                                                        item.title &&
                                                        !item.icon &&
                                                        !item.svgSrc,
                                                    },
                                                    item.svgClass,
                                                  ],
                                                  style: {
                                                    backgroundColor: item.color,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleOnly(
                                                        item.value,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "only-label",
                                                    },
                                                    [_vm._v("ONLY")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.ids
        ? _c("div", { staticClass: "qp-ids" }, [
            _c(
              "a",
              {
                staticClass: "qp-select-list-btn excluded btn btn-primary",
                attrs: {
                  color: "#024ad8",
                  block: "",
                  depressed: "",
                  large: "",
                },
                on: { click: _vm.onSelectFromList },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "btn-text",
                    attrs: { title: _vm.listSelectButtonTitle },
                  },
                  [_vm._v(_vm._s(_vm.listSelectButtonText))]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.ids && _vm.showSelectionModal
        ? _c(
            "modal",
            {
              staticClass: "selection-table-modal",
              attrs: {
                "header-title": "Select " + _vm.selectionDataset,
                outsideClickWhitelist: _vm.modalOutsideClickWhitelist,
              },
              on: {
                close: function ($event) {
                  _vm.showSelectionModal = false
                },
                cancel: function ($event) {
                  _vm.showSelectionModal = false
                },
                submit: _vm.handleSelectionSubmit,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c("data-selection-table", {
                    staticClass: "data-selection-table",
                    attrs: {
                      "page-size": 20,
                      columns: _vm.selectionTableColumns,
                      "dataset-metadata": _vm.selectionDatasetMetadata,
                      "filter-columns": _vm.selectionTableFilterColumns,
                      "data-index": _vm.selectionTableDataIndex,
                      "dataset-name": _vm.selectionDataset,
                      "display-field": _vm.selectionTableDisplayField,
                      "query-function": _vm.selectionTableQueryFunction,
                      "default-selections": _vm.selectionTableDefaultSelections,
                      "nested-field-separator": "|",
                    },
                    on: { "selections-updated": _vm.handleSelectionsUpdated },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }